<template>
  <div id="queryMerchantResultIndex">
    <van-nav-bar title="查询结果 - 商家" :border="false"></van-nav-bar>

    <div v-if="true">
      <van-cell-group>
        <van-cell title="社会信用代码" :value="licenseNumber"></van-cell>
        <van-cell title="商家名称" :value="merchantName"></van-cell>
        <van-cell title="联系人" :value="linkman"></van-cell>
      </van-cell-group>

      <div class="flex-column-center margin40">
        <div class="margin-bottom-10">
          <span class="bind-text">绑定员工数</span>
        </div>
        <div class="box-center">
          <span class="all-count">{{count}}</span>
          <icon name="user" class="icon-size icon-all"></icon>
        </div>
      </div>

      <div class="box-center">
        <div class="flex-item-column-center" @click="handleShowValidHCCDetails">
          <div class="margin-bottom-10">
            <span class="bind-text">有效健康证明</span>
          </div>
          <div class="box-center">
            <span class="valid-count">{{validCount}}</span>
            <icon name="certificate" class="icon-size-large icon-valid"></icon>
          </div>
        </div>
        <div class="flex-row-divider"></div>
        <div class="flex-item-column-center" @click="handleShowInvalidHCCDetails">
          <div class="margin-bottom-10">
            <span class="bind-text">无效健康证明</span>
          </div>
          <div class="box-center">
            <span class="invalid-count">{{invalidCount}}</span>
            <icon name="certificate" class="icon-size-large icon-invalid"></icon>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="false" class="result">
      <van-icon name="warning-o" size="50px" color="#f56a00"></van-icon>
      <p class="title">查询无效</p>
      <p class="info">没有查到相关信息</p>
    </div>
  </div>
</template>

<script>
import { NavBar, Field, CellGroup, Cell, Icon, Toast } from "vant"
import { API } from "../../../assets/js/api"
export default {
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
  },
  data() {
    return {
      licenseNumber: '',
      merchantName: '',
      linkman: '',
      count: null,
      validCount: null,
      invalidCount: null
    }
  },
  created() {
    this.licenseNumber = this.$route.params.licenseNumber;
    this.getMerchantHomeData();
  },
  methods: {
    getMerchantHomeData() {
      this.$loading('加载数据中');

      this.$http({
        url: API['get_merchant_info'],
        type: 'get',
        data: {
          licenseNumber: this.licenseNumber
        }
      }).then(res => {
        Toast.clear();

        if(res.success) {
          this.licenseNumber = res.data.merchantInfo.licenseNumber;
          this.merchantName = res.data.merchantInfo.name;
          this.linkman = res.data.merchantInfo.linkman;

          this.count = res.data.employeeInfo;

          this.validCount = res.data.hcCertificateInfo.validCount;
          this.invalidCount = res.data.hcCertificateInfo.invalidCount;
        } else {
          this.$message(res.msg)
        }
      }).catch(err => {
        Toast.clear();
        console.log(err);
      })
    },
    handleShowValidHCCDetails() {
      if(this.validCount === 0) {
        Toast('暂无相关信息')
      } else {
        this.$router.push({path: '/public/HCCDetailsList/0', query: {licenseNumber: this.licenseNumber}})
      }
    },
    handleShowInvalidHCCDetails() {
      if(this.invalidCount === 0) {
        Toast('暂无相关信息')
      } else {
        this.$router.push({path: '/public/HCCDetailsList/1', query: {licenseNumber: this.licenseNumber}})
      }
    }
  }
}
</script>

<style lang="less" scoped>
#queryMerchantResultIndex {
  .am-list-content {
    color: #000 !important;
  }

  .flex-column-center {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  .margin40 {
    margin: 20px 0;
  }

  .icon-size {
    width: 26px;
    height: 26px;
  }

  .icon-size-large {
    width: 37.5px;
    height: 37.5px;
  }

  .box-center {
    display: flex;
    align-items: center;
  }

  .all-count {
    font-size: 25px;
    color: #108ee9;
  }

  .icon-all {
    color: #108ee9;
  }

  .valid-count {
    font-size: 25px;
    color: #00a854;
  }

  .icon-valid {
    color: #00a854;
  }

  .invalid-count {
    font-size: 25px;
    color: #f04134;
  }

  .icon-invalid {
    color: #f04134;
  }

  .margin-bottom-10 {
    margin-bottom: 10px;
  }

  .flex-item-column-center {
    .flex-column-center;
    flex-grow: 1;
  }

  .flex-row-divider {
    width: 1PX;
    height: 50px;
    background-color: #BBB;
  }

  .hcc-detail-container {
    display: flex;
    align-items: center;

    p {
      margin: 0;
      white-space: normal;
      font-size: 0.24rem;
    }
  }

  .action-container {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0.3rem;
    background-color: #f5f5f9;
  }
}

.bind-text {
  color: #888;
  font-size: 20px;
}

.result {
  height: auto;
  text-align: center;
  padding: 22.5px 0;
  background-color: #fff;
}

.icon-warning {
  width: 50px;
  height: 50px;
}

.title {
  font-size: 18px;
  margin: 10px 0;
}

.info {
  font-size: 15px;
  color: #bbb;
}
</style>

